






























import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins, Ref } from "vue-property-decorator";
import DadosLead from "./components/DadosLead.vue";
import AcoesLead from "./components/AcoesLead.vue";
import HistoricoEtapas from "./components/HistoricoEtapas.vue";
import Tooltip from "@/shared/components/tooltip.vue";

@Component({
  components: { Tooltip, DadosLead, AcoesLead, HistoricoEtapas },
})
export default class AtendimentoLead extends Mixins(GlobalMixin){
  @Ref('acoesLead') readonly acoesLead!: AcoesLead;
  @Ref('historicoEtapa') readonly historicoEtapa!: HistoricoEtapas;

  onLeadChange(){
    this.acoesLead?.fetchAcoesLeads();
    this.historicoEtapa?.fetchHistoricoEtapas();
  }

  voltar() {
    this.$router.back();
  }
}
